
import React, { useState } from 'react';
import { Book } from 'lucide-react';
import QuizCard from '@/components/QuizCard';
import ProgressBar from '@/components/ProgressBar';
import QuizResults from '@/components/QuizResults';
import TopicSelector from '@/components/TopicSelector';
import { useQuiz } from '@/context/QuizContext';

const Index = () => {
  const { 
    currentQuestion, 
    currentQuestionIndex, 
    topics, 
    currentTopic,
    currentSubTopic, 
    nextQuestion, 
    handleAnswer, 
    correctAnswers, 
    isComplete, 
    topicQuestions, 
    totalQuestionsInTopic,
    setCurrentTopic, 
    resetQuiz 
  } = useQuiz();

  const handleBackToTopics = () => {
    setCurrentTopic(null);
  };

  // Get the proper topic title with subtopic if applicable
  const getTopicTitle = () => {
    const topic = topics.find(t => t.id === currentTopic);
    if (!topic) return '';
    
    if (currentTopic === 'taj101' && currentSubTopic) {
      const subtopicTitle = currentSubTopic
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      return `${topic.title} - ${subtopicTitle}`;
    }
    
    return topic.title;
  };

  return (
    <div className="min-h-screen bg-background px-4 py-8 md:py-12">
      <header className="max-w-4xl mx-auto text-center mb-12">
        <div className="inline-flex items-center justify-center p-2 bg-primary/10 rounded-full mb-4">
          <Book className="h-6 w-6 text-primary" />
        </div>
        <h1 className="text-4xl md:text-5xl font-serif font-bold mb-3">
          Essential Islamic Knowledge
        </h1>
        <p className="arabic-subtitle text-center mb-2">
          العِلْمُ الإسْلامِيُّ الأَساسِي
        </p>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Test your knowledge of fundamental Islamic concepts with these practice questions based on Year One curriculum.
        </p>
      </header>

      <main className="max-w-4xl mx-auto pb-12">
        {!currentTopic ? (
          <TopicSelector topics={topics} onSelectTopic={setCurrentTopic} />
        ) : (
          <>
            {!isComplete ? (
              <>
                <div className="mb-4 text-center">
                  <h2 className="text-2xl font-serif font-bold">{getTopicTitle()}</h2>
                </div>
                <ProgressBar 
                  current={currentQuestionIndex + 1} 
                  total={topicQuestions.length} 
                  correctAnswers={correctAnswers}
                  totalInTopic={totalQuestionsInTopic}
                />
                
                {currentQuestion && (
                  <QuizCard 
                    question={currentQuestion}
                    onNext={nextQuestion}
                    onAnswer={handleAnswer}
                    isLast={currentQuestionIndex === topicQuestions.length - 1}
                    onBackToTopics={handleBackToTopics}
                  />
                )}
              </>
            ) : (
              <QuizResults 
                correctAnswers={correctAnswers}
                totalQuestions={topicQuestions.length}
                onRetry={resetQuiz}
                onNewTopic={handleBackToTopics}
              />
            )}
          </>
        )}
      </main>

      <footer className="mt-auto text-center text-sm text-muted-foreground py-6">
        <p>© {new Date().getFullYear()} Essential Islamic Knowledge. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Index;
